<template>
  <v-card title="银行对账单接口日志">
    <div class="grid-demo">
      <v-more-panel>
        <v-form slot="form">
          <v-form-item label="发送日期">
            <v-date-picker v-model="options.fsrqq"></v-date-picker>
            -
            <v-date-picker v-model="options.fsrqz"></v-date-picker>
          </v-form-item>
          <v-form-item label="状态"
            ><v-select
              style="width: 100px"
              v-model="options.zt"
              :data="zt_options"
            ></v-select
          ></v-form-item>
          <v-form-item label="批次号">
            <v-input placeholder="" v-model="options.pch"></v-input>
          </v-form-item>
        </v-form>
        <v-form-item>
          <v-button type="primary" icon="search" @click="findList()"
            ><span>查询</span></v-button
          >
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid v-bind="xGridOptions" size="mini" ref="xTable" :data="tableData">
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  fsrqq: "",
  fsrqz: "",
  zt: "2",
  pch: "",
};
let pagination = {
  sort: "fsrq",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1,
};
let zt_options = [
  { value: "1", label: "成功" },
  { value: "2", label: "失败" },
];
export default {
  data() {
    return {
      pagination,
      options,
      zt_options,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        loading:false,
        height: 450,
        headerAlign: "center",
        columns: [
          {
            field: "rn",
            title: "序号",
            align: "center",
            sortable: true,
          },
          {
            field: "pch",
            title: "批次号",
            align: "center",
            sortable: true,
          },
          {
            field: "zje",
            title: "总金额",
            align: "right",
            headerAlign: "center",
            formatter: "formatNumber",
            sortable: true,
          },
          {
            field: "bz",
            title: "币种",
            align: "center",
            sortable: true,
          },
          {
            field: "zbs",
            title: "总笔数",
            align: "center",
            sortable: true,
          },
          {
            field: "zpc",
            title: "总批次",
            align: "center",
            sortable: true,
          },
          {
            field: "remark",
            title: "备注",
            align: "center",
            sortable: true,
          },
          {
            field: "fsrq",
            title: "发送日期",
            align: "center",
            sortable: true,
          },
          {
            field: "zt",
            title: "状态",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let zt = "";
                if (row.zt == "1") {
                  zt = "成功";
                } else {
                  zt = "失败";
                }
                return [<span>{zt}</span>];
              },
            },
          },
          {
            field: "yy",
            title: "失败原因",
            align: "center",
            sortable: true,
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.xGridOptions.loading = true
      this.$axios
        .get("api/system/logcx/get-yhdzdjklog-list?cx=" + JSON.stringify(this.options), {
          params: this.pagination,
        })
        .then((res) => {
          this.tableData = res.data.data;
          this.pagination.totalresult = res.data.total;
          this.xGridOptions.loading = false
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/yhdzdjklog.vue